// extracted by mini-css-extract-plugin
module.exports = {"providerRow":"MoreLoginModal_providerRow__PhWat","providerName":"MoreLoginModal_providerName__AaEu3","providerIcon":"MoreLoginModal_providerIcon__1mjIC"};